type StateAction<
    T,
    O extends Record<string, unknown> = Record<string, unknown>,
> = (updates: Partial<T>, options: O) => void

export const customStateWrapper =
    <T, O extends Record<string, unknown> = Record<string, unknown>>(
        stateEmitter: StateAction<T, O>,
    ) =>
    (stateSetter: StateAction<T, O>) =>
    (updates: Partial<T>, options?: O): void => {
        const opts = options ?? ({} as O)
        stateSetter(updates, opts)
        stateEmitter(updates, opts)
    }
